import { ThemeOption } from '@helpers/brand';
import { getSrcs } from '@helpers/image';
import { withMotion } from '@hoc/withMotion';
import { LinkButton } from '@stories/Components/Buttons/Button/Button';
import * as React from 'react';
import { FocusRing } from 'react-aria';
import S from '../Header.styles';
import { findFirstFocusableElementAfter } from '@helpers/navigation';
const DesktopNavigation = (props) => {
    const [activeId, setActiveId] = React.useState('');
    const navRef = React.useRef(null);
    React.useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === 'Escape' && navRef.current) {
                const nextFocusable = findFirstFocusableElementAfter(navRef.current);
                if (nextFocusable) {
                    event.preventDefault();
                    nextFocusable.focus();
                }
            }
        };
        if (navRef.current) {
            navRef.current.addEventListener('keydown', handleKeyDown);
        }
        return () => {
            if (navRef.current) {
                navRef.current.removeEventListener('keydown', handleKeyDown);
            }
        };
    }, []);
    if (!props.links) {
        return null;
    }
    const handleActivateChange = (id) => {
        if (id) {
            setActiveId(id);
        }
        else {
            setActiveId('');
        }
    };
    return (React.createElement(S.DesktopNav, { ref: navRef },
        React.createElement(S.Inner, { as: "ul" }, props.links.map((link) => (React.createElement(NavLink, { key: link.id, activeId: activeId, onActivateChange: handleActivateChange, ...link }))))));
};
const NavLink = (props) => {
    const theme = props.theme ? props.theme : ThemeOption.Orange;
    const dropDownRef = React.useRef(null);
    const linkCols = Math.floor(props.sectionLinks.length / 6) + 1;
    const srcs = props.sectionPromotion?.image?.src &&
        getSrcs(props.sectionPromotion.image, 260, 195, 2, 180 / 240);
    return (React.createElement(S.DesktopNavItem, { tabIndex: props.activeId !== props.id ? -1 : undefined, "data-is-active": props.activeId === props.id, onFocus: () => props.onActivateChange(props.id), onBlur: () => props.onActivateChange(), onMouseOver: () => props.onActivateChange(props.id), onMouseLeave: () => props.onActivateChange(), "data-component-theme": theme },
        React.createElement(FocusRing, { focusRingClass: "focus-ring" },
            React.createElement(S.DesktopPrimaryNavLink, { href: props.page.url, target: props.page.target },
                props.page.text,
                ' ')),
        props.sectionLinks.length > 0 && (React.createElement(S.DropdownMenuWrapper, null,
            React.createElement(S.Inner, { ref: dropDownRef },
                React.createElement(S.DropdownMenuColumn, null,
                    props.page.text && React.createElement(S.IntroTitle, null, props.page.text),
                    React.createElement(S.LinkColumn, { "data-column-amount": linkCols },
                        props.sectionLinks.map((link, i) => (React.createElement(S.DropdownMenuItem, { key: link.id, style: { gridRow: i + 1 - 6 * Math.floor(i / 6) } },
                            React.createElement(FocusRing, { focusRingClass: "focus-ring" },
                                React.createElement(S.DropdownMenuLink, { href: link.url, target: link.target }, link.text))))),
                        props.sectionPromotion && (React.createElement(S.PromotionItem, null,
                            React.createElement(S.PromotionItemInner, null,
                                srcs && (React.createElement(S.PromoMedia, null,
                                    React.createElement(S.PromoImage, { alt: props.sectionPromotion?.image?.altText ?? '', loading: "eager", role: props.sectionPromotion?.image?.altText ? undefined : 'presentation', src: srcs[0].split(' ')[0], srcSet: srcs.join(',') }))),
                                props.sectionPromotion?.link.url && (React.createElement(LinkButton, { styleType: "border", title: props.sectionPromotion?.link.text ?? '', href: props.sectionPromotion?.link.url, theme: theme }))))))))))));
};
export default withMotion(DesktopNavigation);
